import { POK_NAME } from '../constants.js';
import { slugs } from '../hooks/slugs.js';
import { canonicalPath } from './siteUrl.js';

export const localizedAsset = (resource, currentLocale, defaultLocale) => {
    const resourceParts = resource.split('.');
    switch (currentLocale) {
        case 'es':
        case 'pt':
            return resourceParts[0].concat(`_${currentLocale}.`).concat(resourceParts[1]);
        default:
            return resourceParts[0].concat(`_${defaultLocale}.`).concat(resourceParts[1]);
    }
};

export const langs = ['en', 'es', 'pt'];

function normalizePath(pathname) {
    const parts = canonicalPath(pathname).split('/').filter(Boolean);
    if (langs.includes(parts[0])) parts.shift();
    return parts.join('/');
}

/** Slug key (the `slugs` entry, which is also the `metas.<key>` namespace) of a pathname, or null
 * for utility/ads routes that live outside the slug map. */
export function findSlugKey(pathname) {
    const path = normalizePath(pathname);
    for (const [key, translations] of Object.entries(slugs)) {
        for (const slug of Object.values(translations)) {
            if (slug === path) return key;
        }
    }
    return null;
}

export function localizedPath(key, lang) {
    const slug = slugs[key][lang] || slugs[key].en;
    return `/${lang}${slug ? `/${slug}` : ''}`;
}

export function buildPageMeta(title, description, url, ogImage) {
    const metas = [
        { title },
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: url },
        { property: 'og:site_name', content: POK_NAME },
        { name: 'twitter:card', content: ogImage ? 'summary_large_image' : 'summary' },
        { name: 'twitter:site', content: '@POK_tech' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
    ];
    if (ogImage) {
        metas.push({ property: 'og:image', content: ogImage });
        metas.push({ name: 'twitter:image', content: ogImage });
    }
    return metas;
}
